
export class Metro {

  constructor(
    public id: number,
    public line: number,
    public title: string,
  ) {}
}
